import { AuxValueGroup } from 'RestAPIs/AuxiliaryValues';

import { AuxFormValues } from './AuxValuesForm.types';

const getAuxValueGroupName = (
  id: string | number,
  auxValueGroups: AuxValueGroup[] = []
) => {
  return auxValueGroups.find((group) => group.name === id)?.name;
};

export const convertPayloadForSave = (
  payload: AuxFormValues,
  auxValueGroups?: AuxValueGroup[]
) => {
  return {
    ...payload,
    auxValueGroupName: getAuxValueGroupName(
      payload.auxValueGroupId,
      auxValueGroups
    ),
    flags: payload.notInUse ? ['UNUSED'] : []
  };
};
